/* eslint-disable react/prop-types */
import './index.scss';
import ModalBase from '.';
import { LocalFilterForm, ModalProps } from '../../types';
import 'react-datepicker/dist/react-datepicker.css';
import { useMemo, useState } from 'react';
import { Select } from '@piggytechng/component-library';
import { OverideButtonStyle, OverideSelectStyle } from '../../helpers/utils';
import DatePicker from 'react-datepicker';
import { FaCalendarAlt } from 'react-icons/fa';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

function ModalFilter({ filterDataBy, modalIsOpen, setIsOpen, searchContext, isLargeWithdrawals }: ModalProps) {
  const closeModal = () => setIsOpen(false);

  const SelectStyle = { ...OverideSelectStyle, style: { ...OverideSelectStyle.style, zIndex: undefined } };

  const [filterTerms, setFilterTerm] = useState<LocalFilterForm>({
    usdrequests: { status: '', start: null, end: null },
    usdrequestsHeld: { status: '', startDate: null, endDate: null },
    withdrawalManager: { statusFilter: '', modeFilter: '', startDate: null, endDate: null, destination: '' },
  });

  const modalTile = useMemo(() => {
    switch (searchContext) {
      case 'filter-usd-requests':
        return 'Filter USD Requests';
      case 'filter-withdrawal-manager':
        return 'Filter Withdrawal Manager';
      case 'filter-usd-requests-held':
        return 'Filter Held USD Requests';
      default:
        return 'Filter';
    }
  }, [searchContext]);

  const modalType = useMemo(() => {
    switch (searchContext) {
      case 'filter-usd-requests':
        return 'usdrequests';
      case 'filter-withdrawal-manager':
        return 'withdrawalManager';
      case 'filter-usd-requests-held':
        return 'usdrequestsHeld';
      default:
        return undefined;
    }
  }, [searchContext]);

  const [options] = useState({
    usdRequestStatus: [
      { label: 'Approved', value: 'approved' },
      { label: 'Returned', value: 'returned' },
      { label: 'Under Review', value: 'under review' },
      { label: 'Processing', value: 'processing' },
    ],
    withdrawalManagerStatus: [
      { label: 'Success', value: 'success' },
      { label: 'Pending', value: 'pending' },
      { label: 'Reversed', value: 'reversed' },
    ],
    withdrawalManagerMode: [
      { label: 'Initiated', value: 'Initiated' },
      { label: 'Paystack', value: 'Paystack' },
      { label: 'Patronize', value: 'Patronize' },
      { label: 'Flex', value: 'Flex' },
    ],
    destination: [
      { label: 'Pocket', value: 'pocket' },
      { label: 'Bank', value: 'bank' },
    ],
  });

  // On Hold only exists in the large withdrawals queue.
  const withdrawalStatusOptions = useMemo(
    () =>
      isLargeWithdrawals
        ? [...options.withdrawalManagerStatus, { label: 'On Hold', value: 'onHold' }]
        : options.withdrawalManagerStatus,
    [isLargeWithdrawals, options.withdrawalManagerStatus],
  );

  const resetfilterTerms = () => {
    const reset: LocalFilterForm = {
      usdrequests: { status: '', start: null, end: null },
      usdrequestsHeld: { status: '', startDate: null, endDate: null },
      withdrawalManager: { statusFilter: '', modeFilter: '', startDate: null, endDate: null, destination: '' },
    };
    setFilterTerm(reset);
    filterDataBy &&
      filterDataBy({
        usdrequests: { status: '', start: '', end: '' },
        withdrawalManager: { statusFilter: '', modeFilter: '', startDate: '', endDate: '', destination: '' },
        usdrequestsHeld: { status: '', startDate: '', endDate: '', limit: 100, cursor: '' },
      });
    closeModal();
  };

  const handleSearch = (e: { preventDefault: () => void }) => {
    e.preventDefault();

    filterDataBy &&
      filterDataBy({
        usdrequests: {
          status: filterTerms.usdrequests.status,
          start: filterTerms.usdrequests.start ? dayjs(filterTerms.usdrequests.start).utc().toISOString() : '',
          end: filterTerms.usdrequests.end ? dayjs(filterTerms.usdrequests.end).add(1, 'day').utc().toISOString() : '',
          limit: 100,
        },
        usdrequestsHeld: {
          status: filterTerms.usdrequestsHeld.status,
          startDate: filterTerms.usdrequestsHeld.startDate
            ? dayjs(filterTerms.usdrequestsHeld.startDate).utc().toISOString()
            : '',
          endDate: filterTerms.usdrequestsHeld.endDate
            ? dayjs(filterTerms.usdrequestsHeld.endDate).add(1, 'day').utc().toISOString()
            : '',
          limit: 100,
          cursor: '',
        },
        withdrawalManager: {
          statusFilter: filterTerms.withdrawalManager.statusFilter,
          modeFilter: filterTerms.withdrawalManager.modeFilter,
          startDate: filterTerms.withdrawalManager.startDate
            ? dayjs(filterTerms.withdrawalManager.startDate).format('YYYY-MM-DD')
            : '',
          endDate: filterTerms.withdrawalManager.endDate
            ? dayjs(filterTerms.withdrawalManager.endDate).format('YYYY-MM-DD')
            : '',
          destination: filterTerms.withdrawalManager.destination,
        },
      });

    closeModal();
  };

  const handleIconClick = (id: string) => {
    const input = document.querySelector(`#${id}`);
    if (input) (input as HTMLElement).click();
  };

  return (
    <ModalBase modalIsOpen={modalIsOpen} setIsOpen={setIsOpen}>
      <div className="modal-search">
        <div className="modal-search__header">
          <h2>{modalTile}</h2>
          <button onClick={closeModal}>&times;</button>
        </div>

        <form className="modal-search__body usd-form-modal-filter" onSubmit={handleSearch}>
          {/* USD Requests Modal */}
          {(modalType === 'usdrequests' || modalType === 'usdrequestsHeld') && (
            <>
              {modalType === 'usdrequests' && (
                <Select
                  {...SelectStyle}
                  label="Request Status"
                  placeholder="Select status"
                  options={options.usdRequestStatus}
                  height="57px"
                  backgroundColor="#F7F7F7"
                  labelStyle={{ color: '#666766' }}
                  value={filterTerms.usdrequests.status}
                  onChange={(e) =>
                    setFilterTerm({ ...filterTerms, usdrequests: { ...filterTerms.usdrequests, status: e } })
                  }
                />
              )}

              {/* Start Date */}
              <div className="input-cont flex--4">
                <label>Start Date</label>
                <DatePicker
                  id="usd-start"
                  selected={
                    modalType === 'usdrequests' ? filterTerms.usdrequests.start : filterTerms.usdrequestsHeld.startDate
                  }
                  onChange={(date) => {
                    console.log(date, 'dd MMMM, yyyy');
                    setFilterTerm({
                      ...filterTerms,
                      [modalType]: {
                        ...filterTerms[modalType],
                        [modalType === 'usdrequests' ? 'start' : 'startDate']: date,
                      },
                    });
                  }}
                  className="date-picker"
                  maxDate={
                    modalType === 'usdrequests'
                      ? filterTerms.usdrequests.end || new Date()
                      : filterTerms.usdrequestsHeld.endDate || new Date()
                  }
                  placeholderText="Select start date"
                  dateFormat="dd MMMM, yyyy"
                />
                <FaCalendarAlt onClick={() => handleIconClick('usd-start')} className="calendar" color="#212337" />
              </div>

              {/* End Date */}
              <div className="input-cont flex--4">
                <label>End Date</label>
                <DatePicker
                  id="usd-end"
                  disabled={
                    modalType === 'usdrequests'
                      ? !filterTerms.usdrequests.start
                      : !filterTerms.usdrequestsHeld.startDate
                  }
                  selected={
                    modalType === 'usdrequests' ? filterTerms.usdrequests.end : filterTerms.usdrequestsHeld.endDate
                  }
                  onChange={(date) =>
                    setFilterTerm({
                      ...filterTerms,
                      [modalType]: {
                        ...filterTerms[modalType],
                        [modalType === 'usdrequests' ? 'end' : 'endDate']: date,
                      },
                    })
                  }
                  minDate={
                    modalType === 'usdrequests'
                      ? filterTerms.usdrequests.start || undefined
                      : filterTerms.usdrequestsHeld.startDate || undefined
                  }
                  maxDate={new Date()}
                  className="date-picker"
                  placeholderText="Select end date"
                  dateFormat="dd MMMM, yyyy"
                />
                <FaCalendarAlt onClick={() => handleIconClick('usd-end')} className="calendar" color="#212337" />
              </div>
            </>
          )}

          {/* Withdrawal Manager Modal */}
          {modalType === 'withdrawalManager' && (
            <>
              <Select
                {...SelectStyle}
                label="Status"
                placeholder="Select status"
                options={withdrawalStatusOptions}
                height="57px"
                backgroundColor="#F7F7F7"
                labelStyle={{ color: '#666766' }}
                value={filterTerms.withdrawalManager.statusFilter}
                onChange={(e) =>
                  setFilterTerm({
                    ...filterTerms,
                    withdrawalManager: { ...filterTerms.withdrawalManager, statusFilter: e },
                  })
                }
              />

              <Select
                {...SelectStyle}
                label="Processor"
                placeholder="Select processor"
                options={options.withdrawalManagerMode}
                height="57px"
                backgroundColor="#F7F7F7"
                labelStyle={{ color: '#666766' }}
                value={filterTerms.withdrawalManager.modeFilter}
                onChange={(e) =>
                  setFilterTerm({
                    ...filterTerms,
                    withdrawalManager: { ...filterTerms.withdrawalManager, modeFilter: e },
                  })
                }
              />

              <Select
                {...SelectStyle}
                label="Destination"
                placeholder="Select Destination"
                options={options.destination}
                height="57px"
                backgroundColor="#F7F7F7"
                labelStyle={{ color: '#666766' }}
                value={filterTerms.withdrawalManager.destination}
                onChange={(e) =>
                  setFilterTerm({
                    ...filterTerms,
                    withdrawalManager: { ...filterTerms.withdrawalManager, destination: e },
                  })
                }
              />

              {/* Start Date */}
              <div className="input-cont flex--4">
                <label>Start Date</label>
                <DatePicker
                  id="wm-start"
                  selected={filterTerms.withdrawalManager.startDate}
                  onChange={(date) =>
                    setFilterTerm({
                      ...filterTerms,
                      withdrawalManager: { ...filterTerms.withdrawalManager, startDate: date, endDate: null },
                    })
                  }
                  className="date-picker"
                  maxDate={filterTerms.withdrawalManager.endDate || new Date()}
                  placeholderText="Select start date"
                  dateFormat="dd MMMM, yyyy"
                />
                <FaCalendarAlt onClick={() => handleIconClick('wm-start')} className="calendar" color="#212337" />
              </div>

              {/* End Date */}
              <div className="input-cont flex--4">
                <label>End Date</label>
                <DatePicker
                  id="wm-end"
                  disabled={!filterTerms.withdrawalManager.startDate}
                  selected={filterTerms.withdrawalManager.endDate}
                  onChange={(date) =>
                    setFilterTerm({
                      ...filterTerms,
                      withdrawalManager: { ...filterTerms.withdrawalManager, endDate: date },
                    })
                  }
                  minDate={filterTerms.withdrawalManager.startDate || undefined}
                  maxDate={new Date()}
                  className="date-picker"
                  placeholderText="Select end date"
                  dateFormat="dd MMMM, yyyy"
                />
                <FaCalendarAlt onClick={() => handleIconClick('wm-end')} className="calendar" color="#212337" />
              </div>
            </>
          )}

          {/* Buttons */}
          <div className="modal-search__actions">
            <button type="button" onClick={resetfilterTerms} className="modal-search__actions-reject">
              Close
            </button>

            <button {...OverideButtonStyle} className="modal-search__actions-resolve">
              Apply
            </button>
          </div>
        </form>
      </div>
    </ModalBase>
  );
}

export default ModalFilter;
